var moment = require("moment-timezone");
var now = moment();

export default {
	refIDRegExp: /[!#%^*()\\/\[\]{}<>?|'"&:]/g,
	isGoodRefID(refID) {
		return !(refID.match(this.refIDRegExp) || refID.match(/\s/g));
	},
	toGoodRefID(refID) {
		return refID
			.replace(this.refIDRegExp, "-")
			.replace(/\s/g, "_")
			.toLowerCase();
	},

	scorerID(user) {
		if (user.scorer_id && user.scorer_id != "") {
			return user.scorer_id;
		} else if (user.full_name && user.full_name != "") {
			return user.full_name;
		} else {
			return `${user.first_name} ${user.last_name}`;
		}
	},

	nameWithScorerID(user) {
		var name = "";
		if (user) {
			if (
				user.first_name &&
				user.last_name &&
				user.first_name != "" &&
				user.last_name != ""
			) {
				name += user.first_name + " " + user.last_name;
			} else {
				if (user.first_name && user.first_name != "") {
					name = user.first_name;
				} else if (user.last_name && user.last_name != "") {
					name = user.last_name;
				}
			}
		}

		if (user.scorer_id && user.scorer_id != "") {
			if (name == "") {
				name = user.scorer_id;
			} else {
				name += " (" + user.scorer_id + ")";
			}
		}

		return name;
	},

	nameReverse(user) {
		if (user.first_name && !user.last_name) {
			return user.first_name;
		}

		if (user.last_name && !user.first_name) {
			return user.last_name;
		}

		return `${user.last_name}, ${user.first_name}`;
	},

	responseState(state) {
		switch (state) {
			case 1:
				return "Unscored";
			case 2:
				return "Scored Once";
			case 3:
				return "Resolution";
			case 10:
				return "Complete";
			case 11:
				return "Comparative Judgment";
			case 20:
				return "Withheld";
			case 30:
				return "Review";
			default:
				return "Unknown";
		}
	},

	scoreTypeIcon(type) {
		switch (type) {
			case 1:
				return "done";
			case 2:
				return "done_all";
			case 3:
				return "verified_user";
			case 4:
				return "question";
			default:
				console.error("Unknown score type", type);
				return "help_outline";
		}
	},

	scoreTypeIconClass(type) {
		switch (type) {
			case 11:
				return "fa-user-graduate";
			case 12:
			case 13:
			case 14:
			case 20:
				return "fa-balance-scale";
			case 15:
				return "fa-drafting-compass";
			case 21:
				return "fa-hands-helping";
			default:
				return "";
		}
	},

	scoreTypeName(type) {
		switch (type) {
			case 1:
				return "First";
			case 2:
				return "Second";
			case 3:
				return "Resolution";
			case 4:
				return "Backread";
			case 11:
				return "Training";
			case 12:
				return "Qualification";
			case 13:
				return "Validity";
			case 14:
				return "Calibration";
			case 15:
				return "Rangefinding";
			case 20:
				return "True Score";
			case 21:
				return "Consensus";
			default:
				console.error("Unknown score type", type);
				return "Unknown";
		}
	},

	scoreTypeAbr(type) {
		switch (type) {
			case 1:
				return "1st";
			case 2:
				return "2nd";
			case 3:
				return "Res";
			case 4:
				return "BR";
			default:
				console.error("Unknown score type", type);
				return "??";
		}
	},

	shortDuration(seconds, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (seconds == 0) {
			return placeholder;
		} else if (!seconds) {
			return placeholder;
		} else {
			return moment()
				.startOf("day")
				.seconds(seconds)
				.format("m:ss");
		}
	},

	shortDurationMinutes(seconds) {
		if (seconds == 0) {
			return "—";
		} else if (!seconds) {
			return "—";
		} else {
			return moment()
				.startOf("day")
				.seconds(seconds)
				.format("m");
		}
	},

	shortDurationSeconds(seconds) {
		if (seconds == 0) {
			return "—";
		} else if (!seconds) {
			return "—";
		} else {
			return moment()
				.startOf("day")
				.seconds(seconds)
				.format("ss");
		}
	},

	medDuration(duration, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (duration == 0) {
			return placeholder
		} else if (!duration) {
			return placeholder;
		} else {
			//duration+=86400000
			let seconds = parseInt(duration % 60);
			let minutes = parseInt((duration / 60) % 60);
			let hours = parseInt(duration / (60 * 60));

			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;

			return hours + ":" + minutes + ":" + seconds;
		}
	},

	dateString(date) {
		return moment(date, this.dateFormat).format("LL");
	},

	fullDate(date) {
		return moment(date).format("l LTS");
	},

	medDate(date) {
		return moment(date).format("l LT");
	},

	shortDate(date) {
		return moment(date).format("l");
	},

	time(date) {
		return moment(date).format("LT");
	},

	sinceString(date) {
		return moment(date).fromNow();
	},

	scoringMode(mode) {
		switch (mode) {
			case "SCORING":
				return "Live scoring";
			case "RESOLUTION":
				return "Resolution";
			case "BACKREAD":
				return "Backreading";
			case "QUEUE BACKREAD":
				return "Backreading";
			case "AUDITING":
				return "Auditing";
			case "FLAG QUEUE":
				return "Flag queue";
			case "QC_TRUE_SCORE":
				return "QC";
			default:
				return "Unknown";
		}
	},

	qcType(type) {
		switch (type) {
			case 1:
				return "Training";
			case 2:
				return "Qualification";
			case 3:
				return "Validity";
			case 4:
				return "Calibration";
			case 5:
				return "Rangefinding";
			default:
				return "???";
		}
	},

	fixed1d(num, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (num == Number.POSITIVE_INFINITY || isNaN(num)) {
			return placeholder;
		} else {
			return num.toFixed(1);
		}
	},

	fixed12d(num, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (num == Number.POSITIVE_INFINITY || isNaN(num)) {
			return placeholder;
		} else if ((num * 10) % 1 == 0) {
			return num.toFixed(1);
		} else {
			return num.toFixed(2);
		}
	},

	fixed012d(num, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (num == Number.POSITIVE_INFINITY || isNaN(num)) {
			return placeholder;
		} else if (num % 1 == 0) {
			return num
		} else if ((num * 10) % 1 == 0) {
			return num.toFixed(1);
		} else {
			return num.toFixed(2);
		}
	},

	fixedPercent1d(percent, placeholder) {
		if (placeholder == null) placeholder = "——"
		if (
			percent == Number.POSITIVE_INFINITY ||
			isNaN(percent) ||
			percent < 0
		) {
			return placeholder;
		} else {
			return `${percent.toFixed(1, placeholder)}%`;
		}
	},

	calcPercent1d(num, den) {
		return this.fixedPercent1d((num * 100) / den);
	},

	mimeTypeIcon(mimeType) {
		switch (mimeType) {
			case "audio/aac":
				return "fa-file-audio";
			case "video/x-msvideo":
				return "fa-file-video";
			case "image/bmp":
				return "fa-file-image";
			case "application/x-bzip":
				return "fa-file-archive";
			case "application/x-bzip2":
				return "fa-file-archive";
			case "text/csv":
				return "fa-file-excel";
			case "application/msword":
				return "fa-file-word";
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
				return "fa-file-word";
			case "image/gif":
				return "fa-file-image";
			case "text/html":
				return "fa-file-code";
			case "image/jpeg":
				return "fa-file-image";
			case "video/mpeg":
				return "fa-file-video";
			case "application/vnd.oasis.opendocument.presentation":
				return "fa-file-powerpoint";
			case "application/vnd.oasis.opendocument.spreadsheet":
				return "fa-file-excel";
			case "application/vnd.oasis.opendocument.text":
				return "fa-file-word";
			case "audio/ogg":
				return "fa-file-audio";
			case "video/ogg":
				return "fa-file-video";
			case "image/png":
				return "fa-file-image";
			case "application/pdf":
				return "fa-file-pdf";
			case "application/vnd.ms-powerpoint":
				return "fa-file-powerpoint";
			case "application/vnd.ms-excel":
				return "fa-file-excel";
			case "application/vnd.ms-word":
				return "fa-file-excel";
			case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
				return "fa-file-powerpoint";
			case "application/x-rar-compressed":
				return "fa-file-archive";
			case "application/rtf":
				return "fa-file-alt";
			case "image/svg+xml":
				return "fa-file-image";
			case "application/x-shockwave-flash":
				return "fa-file-video";
			case "image/tiff":
				return "fa-file-image";
			case "text/plain":
				return "fa-file-alt";
			case "audio/wav":
				return "fa-file-audio";
			case "audio/webm":
				return "fa-file-audio";
			case "video/webm":
				return "fa-file-video";
			case "image/webp":
				return "fa-file-image";
			case "application/zip":
				return "fa-file-archive";
			case "application/x-7z-compressed":
				return "fa-file-archive";
			default:
				return "fa-file";
		}
	},

	scanIntervals: [
		{
			string: "never",
			label: "Never"
		},
		{
			string: "hourly",
			label: "Hourly"
		},
		{
			string: "daily",
			label: "Daily"
		}
	],

	dateFormat: "MMMM DD, YYYY",
	timeFormat: "h:mm A",
	timezones: [
		{
			string: "America/Los_Angeles",
			label: `Pacific Time (${now
				.tz("America/Los_Angeles")
				.format("zz")})`
		},
		{
			string: "America/Denver",
			label: `Mountain Time (${now.tz("America/Denver").format("zz")})`
		},
		{
			string: "America/Chicago",
			label: `Central Time (${now.tz("America/Chicago").format("zz")})`
		},
		{
			string: "America/New_York",
			label: `Eastern Time (${now.tz("America/New_York").format("zz")})`
		}
	],

	timezone(tzString) {
		let tz = _.find(this.timezones, { string: tzString });
		return tz ? tz.label : "Unknown";
	},

	intToDay(weekdayInt, abr) {
		switch (weekdayInt) {
			case 0:
				return abr ? "sun" : "Sunday";
			case 1:
				return abr ? "mon" : "Monday";
			case 2:
				return abr ? "tue" : "Tuesday";
			case 3:
				return abr ? "wed" : "Wednesday";
			case 4:
				return abr ? "thu" : "Thursday";
			case 5:
				return abr ? "fri" : "Friday";
			case 6:
				return abr ? "sat" : "Saturday";
			case 7:
				return abr ? "all" : "Every Day";
		}
	},

	dayToInt(weekday) {
		switch (weekday) {
			case "sun":
			case "Sunday":
				return 0;
			case "mon":
			case "Monday":
				return 1;
			case "tue":
			case "Tuesday":
				return 2;
			case "wed":
			case "Wednesday":
				return 3;
			case "thu":
			case "Thursday":
				return 4;
			case "fri":
			case "Friday":
				return 5;
			case "sat":
			case "Saturday":
				return 6;
			case "all":
			case "Every Day":
				return 7;
		}
	},

	qcTags: [
		{
			label: "Anchor",
			abr: "A",
			id: 1
		},
		{
			label: "Further Review",
			abr: "FR",
			id: 2
		},
		{
			label: "Do Not Use",
			abr: "DNU",
			id: 3
		},
		{
			label: "Training",
			abr: "T",
			id: 4
		},
		{
			label: "Qualification",
			abr: "Q",
			id: 5
		},
		{
			label: "Validity",
			abr: "V",
			id: 6
		},
		{
			label: "Calibration",
			abr: "C",
			id: 7
		}
	],

	qcTagAbrs(tagIDs) {
		let abrs = [];
		let sortedIDs = _.cloneDeep(tagIDs);
		sortedIDs.sort();
		_.each(sortedIDs, id => {
			let tag = _.find(this.qcTags, { id: id });
			if (tag) {
				abrs.push(tag.abr);
			} else {
				abrs.push("?");
			}
		});

		return abrs.join(", ");
	},

	qcTagColor(tag) {
		return `rgb(${tag.r}, ${tag.g}, ${tag.b}) !important`;
	},

	qcTagBgColor(tag) {
		if (tag) {
			return `rgba(${tag.r}, ${tag.g}, ${tag.b}, 0.2) !important`;
		} else {
			return ``;
		}
	},

	qcTagObject(tagID) {
		return _.find(this.qcTags, { id: tagID });
	},

	isObjectId(str) {
		return str && str.match(/^[0-9a-fA-F]{24}$/);
	},

	fileSize(size) {
		if (!size) {
			return null;
		}

		if (size > 1024 * 1024 * 1024) {
			let gb = size / (1024 * 1024 * 1024);
			return `${gb.toFixed(2)} GB`;
		} else if (size > 1024 * 1024) {
			let mb = size / (1024 * 1024);
			return `${mb.toFixed(1)} MB`;
		} else if (size > 1024) {
			return `${Math.ceil(size / 1024)} KB`;
		} else {
			return `${size} bytes`;
		}
	}
};



// WEBPACK FOOTER //
// ./src/services/FormatService.js